import { getTypeOrNull } from './apollo';
import { AdminV1AccountMode, useAccountSetupQuery } from './graphql';

export const CONFIDENCE_CLOUD_WAREHOUSE = 'dataWarehouses/confidence-managed';

type AccountMode = {
  loading: boolean;
  isTotalConfidence: boolean;
  isWarehouseNative: boolean;
  hasManagedDataWarehouse: boolean;
  hasConfidenceCloud: boolean;
  hasCustomerWarehouse: boolean;
};

export const useAccountMode = (): AccountMode => {
  const { data, loading } = useAccountSetupQuery({
    fetchPolicy: 'cache-first',
  });

  const currentAccountData = getTypeOrNull(data?.currentAccount);
  const existsDataWarehouses = getTypeOrNull(data?.existsDataWarehouses);

  const isTotalConfidence =
    currentAccountData?.mode === AdminV1AccountMode.TotalConfidence;
  const isWarehouseNative =
    currentAccountData?.mode === AdminV1AccountMode.WarehouseNative;
  const hasManagedDataWarehouse = !!getTypeOrNull(
    data?.dataWarehouses,
  )?.dataWarehouses?.some(
    dataWarehouse => dataWarehouse?.name === CONFIDENCE_CLOUD_WAREHOUSE,
  );
  return {
    loading,
    isTotalConfidence,
    isWarehouseNative,
    hasManagedDataWarehouse,
    hasConfidenceCloud: existsDataWarehouses?.hasManagedWarehouse === true,
    hasCustomerWarehouse: existsDataWarehouses?.hasCustomerWarehouse === true,
  };
};
